:host {

    position: relative;

    font-family: "Fira Sans", sans-serif;

    display: grid;
    gap: 20px;
    grid-template-columns: 1fr;
    grid-template-areas:
        "form"
        "confirmations"
        "navigation";

    @media (min-width: 768px) and (max-width: 1440px) {
        grid-template-columns: auto 300px;
        grid-template-areas:
            "form               navigation"
            "confirmations      navigation";
    }

    @media (min-width: 1440px) {
        grid-template-columns: auto 450px;
        grid-template-areas:
            "form               navigation"
            "confirmations      navigation";
    }

    fert-form-navigation  {
        grid-area: form;
    }

    aside  {
        grid-area: navigation;
        padding-top: 3.3rem;
    }

    @media (max-width: 768px) {
        aside {
            lb-form-navigation {
                display: none;
            }            
        }
    }

    ::slotted(.wizard-sticky-wrapper) {
        display: none;
    }

    a.link {
        float: right;
        font-size: 1.8rem;
        font-style: italic;
        text-decoration: none;
        padding: 16px 4px 0 0;
        line-height: 1.3333333333;
        border-bottom: 1px solid #0a171f;

        &:hover {
            border-bottom-color: transparent;
        }
    }

    .dse-link {
        padding: 3px 65px;
        font-family: "Fira Sans", sans-serif;

        @media (max-width: 768px) {           
            padding-left: 0;            
        }

        h5 {
            margin-bottom: 20px;
            font-size: 2.2rem;
        }

        a {
            font-size: 2rem;
            color: #0077B6;
            text-decoration: underline;
            cursor: pointer;

            &:hover {
                color: #00476D;
            }
        }

        @media (min-width: 1440px) {
            a {
                white-space: nowrap;
            }
        }
    }

    m-content.main {
        clear: both;
        padding: 0;
        padding-top: 0;
        max-width: unset;
        margin: 0;
    }

    m-header {
        z-index: 400;
    }

    c-button.right {
        float: right;
    }

    c-container.keep-alive-warning {
        position: sticky;
        top: 0;
        z-index: 450;
        animation: fadein 2s;
        max-width: 100%;
        margin: 0;
    }

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .confirm-buttons {
        overflow: visible;
        padding-top: 40px;
    }

    form-paging {
        float: left;
        width: fit-content;
        block-size: fit-content;
        margin-top: 15px;
    }

    form-paging + form-paging {
        float: right;
        margin-top: 15px;
        margin-left: 15px;
    }

    lb-tmp-save {
        float: right;
        margin-top: 15px;       
    }
}

::slotted(.wizard-sticky-wrapper) {
    display: none;
}
